// extracted by mini-css-extract-plugin
export var fullGrid = "_3t-3";
export var pdpPreviewContainer = "_3t-1";
export var previewContainer = "_3t-0";
export var togglePreviewContainer = "_3t-2";